import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';

/** STEP 2-P7-H · Receiving UI (REUSE POST /api/operator/receiving) */
export default function OperatorReceiving({ warehouseId }) {
  const [f, setF] = useState({
    warehouse_id: warehouseId || '', seller_id: '',
    product_id: '', variant_key: 'default', quantity: 1 });
  const [result, setResult] = useState(null);
  useEffect(() => { if (warehouseId) setF((s) => ({ ...s, warehouse_id: warehouseId })); },
    [warehouseId]);
  const submit = async () => {
    if (!f.warehouse_id || !f.seller_id || !f.product_id) {
      toast.error('창고 · Seller · Product 를 입력해주세요.'); return;
    }
    const qty = Math.max(1, Number(f.quantity) || 0);
    try {
      const r = await api.post('/operator/receiving', { ...f, quantity: qty });
      toast.success(`입고 완료 · +${r.data.quantity_received}`);
      setResult(r.data);
    } catch (e) {
      const s = e?.response?.status;
      if (s === 403) toast.error('이 작업을 처리할 권한이 없습니다.');
      else toast.error(e?.response?.data?.detail || '입고 실패');
    }
  };
  return (
    <div data-testid="operator-receiving">
      <h1 className="text-lg font-semibold mb-3">입고</h1>
      <div className="bg-white border border-black/10 rounded-md p-4 space-y-2 max-w-xl">
        <Row label="Warehouse" val={f.warehouse_id} testid="receiving-warehouse"
              on={(v) => setF({ ...f, warehouse_id: v })} />
        <Row label="Seller"    val={f.seller_id}     testid="receiving-seller"
              on={(v) => setF({ ...f, seller_id: v })} />
        <Row label="Product"   val={f.product_id}    testid="receiving-product"
              on={(v) => setF({ ...f, product_id: v })} />
        <Row label="Variant"   val={f.variant_key}   testid="receiving-variant"
              on={(v) => setF({ ...f, variant_key: v })} />
        <Row label="Quantity"  val={f.quantity}      testid="receiving-quantity"
              type="number" on={(v) => setF({ ...f, quantity: v })} />
        <button onClick={submit} data-testid="receiving-submit"
                 className="px-3 py-2 bg-[#FF3B30] text-white rounded text-sm">
          입고 처리
        </button>
        {result && (
          <div className="mt-3 text-sm border-t pt-2" data-testid="receiving-result">
            <div>총 재고: <b>{result.after_total}</b></div>
            <div className="text-neutral-500">
              (Location 미적치 재고는 [적치] 메뉴 · 인벤토리 조회 화면에서 확인)
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, val, on, testid, type }) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="w-24 text-neutral-600">{label}</span>
      <input type={type || 'text'} value={val}
              onChange={(e) => on(e.target.value)}
              data-testid={testid}
              className="flex-1 border rounded px-2 py-1 text-sm" />
    </label>
  );
}
